import _get from 'lodash/get';
import { CART_PRODUCT_TYPES } from "../constants/index.js";
var COUPON = CART_PRODUCT_TYPES.COUPON;
/**
 * make rule product factory
 * @param {Function} convertAndFormat convert and format price util
 * @returns {Function} ruleProductFactory
 */
export function makeRuleProductFactoryV2(convertAndFormat, currentCurrency, description) {
  if (convertAndFormat === void 0) {
    convertAndFormat = function convertAndFormat(x) {
      return "" + x;
    };
  }
  if (currentCurrency === void 0) {
    currentCurrency = '';
  }
  if (description === void 0) {
    description = '';
  }
  /**
   * rule product factory
   * @param {Object} rule plain unformatted rule product from cart's products
   * @returns {Object} formatted rule product
   */
  return function ruleProductFactory(rule) {
    var totalPrice = _get(rule, 'price.subTotal');
    var isCoupon = _get(rule, 'category') === COUPON;
    var totalWithVat = _get(rule, 'price.totalWithVat');
    return {
      id: rule.id,
      description: isCoupon ? description : _get(rule, 'description'),
      totalPrice: totalPrice,
      totalWithVat: totalWithVat,
      displayedTotalPrice: convertAndFormat(totalPrice),
      displayedCurrency: currentCurrency,
      isCoupon: isCoupon
    };
  };
}